/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { FSBTable } from 'components/common/FSBTable';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import { offersInActiveColumns } from 'pages/MarketListing/constant';
import {
  ADMIN_UPDATE_OFFER_STATUS,
  DELETE_OFFER,
} from 'pages/MarketListing/MarketListingGraphQL';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { FaArrowUpRightFromSquare } from 'react-icons/fa6';
import { FiRefreshCw } from 'react-icons/fi';
import { defaultDeleteFilter, showSequenceNumber } from 'utils/constants';
import { RECORD_DELETED_SUCCESSFULLY } from 'components/common/FSBToastify/types';
import { setBidDetails } from 'actions/bidDetailAction';
import { setVendorDetails } from 'actions/vendorDetailsAction';
import { cloneDeep, isEmpty } from 'lodash';
import {
  EXPORTS_OFFERS,
  OFFERS_QUERY,
  OFFERS_SUBSCRIPTION_QUERY,
} from 'utils/CommonGraphQL';
import DownloadCSV from 'components/DownloadCSV';
import Loader from 'components/common/Loader';
import ErrorMessage from 'components/ErrorMessage';
import NoDataFound from 'components/NoDataFound';
import FilterResultBar from 'components/FilterResultBar';
import MarketListingMobileView from 'pages/MarketListing/components/MarketListingMobileView';
import ReactivateListingModal from 'pages/MarketListing/components/ReactivateListingModal';

const OffersInActiveTable = ({
  // handleViewDetail,
  searchString,
  filterValue,
  handleResetFilter,
  showAdvancedSearchBar,
  selectedProductName,
}) => {
  const dispatch = useDispatch();
  const [deleteRowId, setDeleteRowId] = useState('');
  const [reactivateRow, setReactivateRow] = useState(null);
  const [rowSelection, setRowSelection] = useState({});
  const [showBulkReactivate, setShowBulkReactivate] = useState(false);
  const [bulkSubmitting, setBulkSubmitting] = useState(false);
  // const [updateRecordModal, setUpdateRecordModal] = useState(false);
  // const [selectedUserRow, setSelectedUserRow] = useState([]);
  const [showDeleteRecord, setDeleteRecord] = useState(false);
  const [filters, setFilters] = useState({
    filter: [
      {
        key: 'entityName',
        joinAttributeName: 'trader',
        value: searchString,
        type: 'STRING',
        op: 'LIKE_OR_NULL',
      },
      {
        key: 'status',
        value: 'EXPIRED,REACTIVATED,INACTIVE',
        type: 'STRING',
        op: 'IN',
      },
      {
        key: 'offerType',
        value: 'All',
        type: 'STRING',
        op: 'EQ',
      },
      { ...defaultDeleteFilter },
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
  });
  // Build the product name filter for GraphQL
  const productNameFilter = useMemo(() => {
    if (!selectedProductName) return [];
    return [
      {
        key: 'name',
        value: selectedProductName,
        joinAttributeName: 'grades.subCategory.product',
        type: 'STRING',
        op: 'EQ',
      },
    ];
  }, [selectedProductName]);

  // Combine all filters for the GraphQL query
  const graphqlVariables = useMemo(() => ({
    filter: [
      ...filters.filter,
      ...filterValue,
      ...productNameFilter,
    ],
    pageNo: filters.pageNo,
    pageSize: filters.pageSize,
    sortCol: filters.sortCol,
    sortDirection: filters.sortDirection,
  }), [filters, filterValue, productNameFilter]);

  const { data, loading, error, refetch, subscribeToMore } = useQuery(
    OFFERS_QUERY,
    {
      variables: graphqlVariables,
      fetchPolicy: 'network-only',
    },
  );
  const [deleteOffer] = useMutation(DELETE_OFFER, {
    // eslint-disable-next-line no-shadow
    onCompleted: () => {
      toast.success(RECORD_DELETED_SUCCESSFULLY);
      setDeleteRowId('');
      setDeleteRecord(!showDeleteRecord);
    },
    onError: () => { },
  });
  const [updateOfferStatus] = useMutation(ADMIN_UPDATE_OFFER_STATUS);

  // const [updateOfferStatus] = useMutation(UPDATE_OFFER_STATUS, {
  //   // eslint-disable-next-line no-shadow
  //   onCompleted: () => {
  //     toast.success(STATUS_UPDATED_SUCCESSFULLY);
  //   },
  //   onError: ({ graphQLErrors }) => {
  //     graphQLErrors.map(({ exception }) => {
  //       toast.error(exception?.message);
  //       return exception;
  //     });
  //   },
  // });

  // const onClickEdit = ({ row }) => {
  //   setUpdateRecordModal(true);
  //   setSelectedUserRow(row?.original);
  // };

  // const onCloseUpdatePopup = () => {
  //   setUpdateRecordModal(false);
  // };

  const toggleDeleteRecord = (id) => {
    setDeleteRecord(!showDeleteRecord);
    setDeleteRowId(id);
  };

  // const onDeleteConfirmation = async () => {
  //   const { id, email } = selectedUserRow;
  //   const rowId = selectedRows.map(({ original }) => original.id);
  //   const rowEmail = selectedRows.map(({ original }) => original.email);
  //   // await deleteUser({
  //   //   variables: {
  //   //     id: id ? [id] : rowId,
  //   //     email: email ? [email] : rowEmail,
  //   //   },
  //   // });

  //   setSelectedRows([]);
  //   setSelectedUserRow([]);
  //   setDeleteRecord(false);
  // };

  // const handlePageChange = (pageSize, pageNumber, sortColumnData) => {
  //   if (sortColumnData?.length && sortColumnData[0]?.id !== null) {
  //     setFilters({
  //       ...filters,
  //       filter: [],
  //       pageNo: pageNumber,
  //       pageSize,
  //       // search: { key: 'name', value: '' },
  //       sortCol: sortColumnData[0]?.id,
  //       sortDirection: sortColumnData[0]?.desc ? 'DESC' : 'ASC',
  //     });
  //   } else {
  //     setFilters({
  //       ...filters,
  //       filter: [],
  //       pageNo: pageNumber,
  //       pageSize,
  //       sortCol: null,
  //       sortDirection: null,
  //     });
  //   }
  // };

  const onDeleteConfirmation = async () => {
    try {
      await deleteOffer({
        variables: { id: deleteRowId },
      });
    } catch (err) {
      toast.error(err);
    }
  };
  // const actionsFormatter = (cell) => {
  //   return (
  //     <ActionsFormatter
  //       isView={false}
  //       handleView={() => handleViewDetail(cell?.row?.original, 'offerType')}
  //       handleEdit={() => onClickEdit(cell)}
  //       handleDelete={() => toggleDeleteRecord(cell?.row?.original?.id)}
  //     />
  //   );
  // };

  // const handleOfferStatus = async (e, cell) => {
  //   try {
  //     await updateOfferStatus({
  //       variables: { id: cell?.row?.original?.id, status: e.target.value },
  //     });
  //     //  refetch();
  //   } catch (err) {
  //     toast.error(err);
  //   }
  // };

  // const statusFormatter = (cell) => {
  //   return (
  //     <StatusFormatter
  //       options={MARKET_LIST_STATUS}
  //       defaultValue={cell?.row?.original?.status}
  //       handleChange={(e) => handleOfferStatus(e, cell)}
  //     />
  //   );
  // };

  const handleLinkClick = (row) => {
    dispatch(
      setBidDetails({
        status: true,
        selectedBid: {
          ...row,
          bidType: 'offer',
          bidOfferType: 'LIVE',
          filters,
        },
      }),
    );
  };

  const linkFormatter = (cell) => {
    return (
      <div
        className="text-blue-c5 fw-medium cursor-pointer d-flex align-items-center"
        onClick={() => handleLinkClick(cell?.row?.original)}
        aria-hidden
      >
        <span className="me-2 f-16">{cell?.row?.original?.id}</span>{' '}
        <FaArrowUpRightFromSquare />
      </div>
    );
  };

  const handleNameClick = (row) => {
    if (!row?.trader?.id) return;
    dispatch(
      setVendorDetails({
        status: true,
        selectedVendor: row.trader,
      }),
    );
  };
  // const nameFormatter = (cell) => {
  //   return (
  //     <div
  //       className="text-blue-c5 fw-medium cursor-pointer"
  //       onClick={() => handleNameClick(cell?.row?.original?.trader)}
  //       aria-hidden
  //     >
  //       {cell?.row?.original?.trader?.firstName}{' '}
  //       {cell?.row?.original?.trader?.lastName}
  //     </div>
  //   );
  // };



  const openReactivateModal = (row) => {
    setReactivateRow(row);
  };

  const closeReactivateModal = () => {
    setReactivateRow(null);
  };

  const selectedIds = Object.keys(rowSelection);

  const resetRowSelection = () => {
    setRowSelection({});
  };

  const toggleBulkReactivate = () => {
    setShowBulkReactivate((prev) => !prev);
  };

  const handleBulkReactivate = async () => {
    if (!selectedIds.length) return;

    try {
      setBulkSubmitting(true);
      await Promise.all(
        selectedIds.map((id) =>
          updateOfferStatus({
            variables: { id, status: 'ACTIVE' },
          }),
        ),
      );
      toast.success(`${selectedIds.length} offers activated successfully`);
      setShowBulkReactivate(false);
      resetRowSelection();
      refetch();
    } catch (err) {
      toast.error(err?.message || 'Failed to activate selected offers');
    } finally {
      setBulkSubmitting(false);
    }
  };

  const renderReactivateButton = (row) => {
    return (
      <button
        type="button"
        className="btn btn-outline-primary btn-sm d-inline-flex align-items-center justify-content-center"
        onClick={() => openReactivateModal(row)}
        title="Reactivate offer"
        aria-label="Reactivate offer"
      >
        <FiRefreshCw />
      </button>
    );
  };

  const reactivateFormatter = (cell) =>
    renderReactivateButton(cell?.row?.original);

  const localOffersInActiveColumns = [...offersInActiveColumns];

  const renderRoleColumn = ({ row }) => {
    // eslint-disable-next-line no-underscore-dangle
    const role = row?.original?.trader?.__typename;
    return (
      <div className="px-1 text-capitalize">
        {role?.toLowerCase() || '-'}
      </div>
    );
  };

  if (!localOffersInActiveColumns.find(c => c.accessorKey === 'role')) {
    localOffersInActiveColumns.push({
      accessorKey: 'role',
      header: 'Role',
      enableSorting: false,
      cell: renderRoleColumn,
    });
  }

  const findIndexOfItem = (item) => {
    return localOffersInActiveColumns.findIndex((itm) => itm.accessorKey === item);
  };

  localOffersInActiveColumns[findIndexOfItem('id')].cell = linkFormatter;
  localOffersInActiveColumns[findIndexOfItem('SNo')].cell = (cell) =>
    showSequenceNumber(cell, filters);
  localOffersInActiveColumns[findIndexOfItem('reactivate')].cell =
    reactivateFormatter;

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: data?.offers?.totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };
  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
        id: filters.sortCol,
        desc: filters.sortDirection === 'DESC',
      },
  ];

  useEffect(() => {
    const updatedFilter = [...filters.filter]; // Clone the filter array
    const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
    updatedFirstFilter.value = searchString;
    updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
    // return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
    refetch({ ...filters, filter: updatedFilter });
  }, [searchString]);

  const onGlobalSearch = (str) => {
    if (str) {
      setFilters((prevFilter) => {
        const updatedFilter = [...prevFilter.filter]; // Clone the filter array
        const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
        updatedFirstFilter.value = str;
        updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
        return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
      });
    }
  };

  useEffect(() => {
    const deletedObj = filters.filter.filter((val) => val.key !== 'isDeleted');
    const unsubscribe = subscribeToMore({
      document: OFFERS_SUBSCRIPTION_QUERY,
      variables: { ...filters, filter: deletedObj },
      updateQuery: (prev, { subscriptionData }) => {
        const newData = cloneDeep(prev);
        const indexFound = newData.offers.offers.findIndex(
          (val) => val.id === subscriptionData.data?.offers?.offer?.id,
        );
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        if (!subscriptionData.data?.offers?.offer?.id) return prev;
        if (subscriptionData.data.offers.action === 'CREATED') {
          const newOffer = subscriptionData.data.offers.offer;
          const updatedOffers = [newOffer, ...newData.offers.offers];

          const newTotalCount = prev.offers.totalCount + 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          newData.offers = {
            ...newData.offers,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            offers: updatedOffers,
          };
        }
        if (subscriptionData.data.offers.action === 'UPDATED') {
          newData.offers.offers[indexFound] =
            subscriptionData.data.offers.offer;
        }

        if (subscriptionData.data.offers.action === 'DELETED') {
          const { id } = subscriptionData.data.offers.offer; // ID of the offer to remove
          const prevOffers = prev.offers.offers;

          const updatedOffers = prevOffers.filter((val) => val.id !== id);

          const newTotalCount = prev.offers.totalCount - 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          const updatedOffersData = {
            ...newData.offers,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            offers: updatedOffers,
          };

          newData.offers = updatedOffersData;
        }

        return newData;
      },
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <Loader />;
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!data?.offers?.offers)
    return <NoDataFound message="Offers not available" />;

  return (
    <>
      {showAdvancedSearchBar && data?.offers?.offers?.length > 0 && (
        <FilterResultBar
          length={data?.offers?.offers?.length}
          type="offers"
          handleResetFilter={handleResetFilter}
        />
      )}
      {/* <FSBModal
        title="Edit Offer"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={updateRecordModal}
        onClose={onCloseUpdatePopup}
        toggleAlert={onCloseUpdatePopup}
        modalClass="right-drawer"
      >
        {selectedUserRow?.offerType === types?.LIVE && (
          <EditLiveWrapper
            onCloseUpdatePopup={onCloseUpdatePopup}
            currentRow={selectedUserRow}
            type={OFFER_AND_DEMAND_TYPE.OFFERTYPE}
          />
        )}
        {selectedUserRow?.offerType === types.FORWARD && (
          <EditForwardWrapper
            onCloseUpdatePopup={onCloseUpdatePopup}
            currentRow={selectedUserRow}
            type={OFFER_AND_DEMAND_TYPE.OFFERTYPE}
          />
        )}
        {selectedUserRow?.offerType === types.FOREIGN && (
          <EditForeignWrapper
            onCloseUpdatePopup={onCloseUpdatePopup}
            currentRow={selectedUserRow}
            type={OFFER_AND_DEMAND_TYPE.OFFERTYPE}
          />
        )}
      </FSBModal> */}
      <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />
      <DeleteConfirmationAlert
        open={showBulkReactivate}
        title="Reactivate"
        message={`Do you want to active selected ${selectedIds.length} offers?`}
        cancelButtonLabel="Close"
        addButtonLabel="Active"
        confirmButtonColor="primary"
        loading={bulkSubmitting}
        onConfirm={handleBulkReactivate}
        onCancel={toggleBulkReactivate}
        toggleAlert={toggleBulkReactivate}
      />
      <ReactivateListingModal
        isOpen={!!reactivateRow}
        kind="offer"
        row={reactivateRow}
        onClose={closeReactivateModal}
        onSuccess={refetch}
      />
      <DownloadCSV
        lazyQuery={EXPORTS_OFFERS}
        filters={{
          filter: graphqlVariables.filter,
          sortCol: filters.sortCol,
          sortDirection: filters.sortDirection,
        }}
        apiKey="exportOffers"
        fileName="InactiveOffers"
        formats={["csv", "excel"]}
        classWrapper="market-listing-download"
        positionTop="-34px"
        positionRight="0"
      />
      {selectedIds.length ? (
        <div className="muiltiple-action-box d-inline-flex align-items-center ps-3 mt-2 mb-1">
          <span className="text-dark me-3">
            Viewing{' '}
            <span className="fw-semibold">{selectedIds.length} selected</span>{' '}
            from list of offers
          </span>
          <button
            type="button"
            className="btn btn-link p-0 d-inline-flex align-items-center"
            onClick={toggleBulkReactivate}
          >
            <FiRefreshCw className="me-1" /> Reactivate
          </button>
        </div>
      ) : null}
      <MarketListingMobileView
        rows={(data && data?.offers?.offers) || []}
        filters={filters}
        kind="offer"
        totalPages={(data && data?.offers?.totalPages) || 0}
        currentPageNo={filters.pageNo}
        currentPageSize={filters.pageSize}
        handlePageChange={handlePageChange}
        onIdClick={handleLinkClick}
        onNameClick={handleNameClick}
        renderStatusControl={(row) => (
          <span className="text-muted">{row?.status || 'N/A'}</span>
        )}
        renderRowAction={renderReactivateButton}
      >
        <FSBTable
          getRowId={(row) => row.id}
          columns={localOffersInActiveColumns}
          data={(data && data?.offers?.offers) || []}
          totalCount={(data && data?.offers?.totalCount) || 0}
          totalPages={(data && data?.offers?.totalPages) || 0}
          currentPageNo={filters.pageNo}
          pageSize={filters.pageSize}
          keyField="id"
          showSearch={false}
          showFilters
          showDelete={false}
          showPagination
          remote
          striped={false}
          hover={false}
          bordered={false}
          wrapperClass="table-responsive word-break"
          handlePageChange={handlePageChange}
          globalSearchStr={filters.filter[0].value}
          onGlobalSearch={onGlobalSearch}
          onSortChange={onSortChange}
          sorting={sortBy}
          searchPlaceholder="Search Vendors"
          onSelectedRowsChange={setRowSelection}
          rowSelection={rowSelection}
        />
      </MarketListingMobileView>
    </>
  );
};
export default OffersInActiveTable;
